import React, { useEffect, useState } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import useThemeStore from "(store)/themeStore";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "styles/PhoneInputStyles.css";
import { getValueFromPath } from "utils";
import { Done } from "@mui/icons-material";

const PhoneField = ({
  name,
  label,
  placeholder,
  size = "small",
  isRequired,
  disabled = false,
  isDynamic = false,
  setIsOpen,
  isVerified,
  error,
}) => {
  const { errors, touched, values, setFieldValue, setFieldTouched } =
    useFormikContext();
  const theme = useThemeStore((state) => state.theme);
  const showError =
    (isDynamic ? getValueFromPath(errors, name) : errors[name]) &&
    (isDynamic ? getValueFromPath(touched, name) : touched[name]);
  const [isFocused, setIsFocused] = useState(false);
  const inputClass =
    theme === "light"
      ? `custom-phone-input ${disabled && "phone-field-disabled"} ${size}`
      : `custom-phone-input-dark ${
          disabled && "phone-field-disabled-dark"
        } ${size}`;
  const buttonClass =
    theme === "light"
      ? isFocused
        ? `custom-phone-button-focused ${
            disabled && "phone-field-disabled"
          } ${size}`
        : `custom-phone-button ${disabled && "phone-field-disabled"} ${size}`
      : isFocused
      ? `custom-phone-button-focused-dark ${size}`
      : `custom-phone-button-dark ${size}`;

  // useEffect(() => {
  //   if (!isVerified) {
  //     setError("Phone number is not verified");
  //   } else {
  //     setError(""); // Clear error if verified
  //   }
  // }, [isVerified, name, setError]);
  return (
    <div className="w-full relative">
      {label && (
        <div className="flex items-center gap-1 mb-1">
          <span className="flex gap-1 items-end relative">
            <span className="label-text dark:text-white">{label}</span>
            {isRequired && (
              <span className="text-red-500 font-extrabold">*</span>
            )}
          </span>
        </div>
      )}
      <PhoneInput
        disabled={disabled}
        variant="outlined"
        placeholder={placeholder}
        value={getValueFromPath(values, name) || values[name]}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          setIsFocused(false);
          setFieldTouched(name, true);
        }}
        disableDropdown
        onChange={(phone) => setFieldValue(name, phone)}
        type="tel"
        onlyCountries={["us"]}
        country={"us"}
        inputStyle={{ fontSize: size === "small" && 12 }}
        inputClass={
          showError
            ? theme === "light"
              ? `custom-phone-error ${size}  `
              : `custom-phone-error-dark ${size}`
            : inputClass
        }
        buttonClass={
          showError
            ? theme === "light"
              ? `custom-phone-error-button ${size}`
              : isFocused
              ? `custom-phone-error-button-focused-dark ${size}`
              : `custom-phone-error-button-dark ${size}`
            : buttonClass
        }
      />
      <div
        className={`absolute border ${
          showError
            ? "bottom-[21px] right-[1px] h-[37.6px]"
            : "bottom-[1px] right-[1px] h-[35px]"
        } border-transparent w-20 rounded-r-lg flex items-center justify-center ${
          showError ? "cursor-not-allowed" : "cursor-pointer"
        } text-secondary dark:text-alpha`}
        onClick={() => {
          !showError && !isVerified && values[name] && setIsOpen(true);
        }}
      >
        {isVerified && !showError ? (
          <Done sx={{ color: "#4BB543" }} />
        ) : (
          "Verify"
        )}
      </div>
      {showError && (
        <ErrorMessage
          className="text-xs text-red-500 mt-1"
          name={name}
          component="div"
        />
      )}
      {error && (
        // <ErrorMessage
        //   className=""
        //   // name={name}
        //   component="div"
        //   render={() =>
        // />
        <p className="text-xs text-red-500 mt-1 absolute">{error}</p>
      )}
    </div>
  );
};

export default PhoneField;
